'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_LINE_ITEM_INPUT = exports.SET_LINE_ITEM_INPUT = undefined;

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

exports.setLineItemInput = setLineItemInput;
exports.clearLineItemInput = clearLineItemInput;
exports.addManyToCart = addManyToCart;
exports.addToCart = addToCart;
exports.addChipToCart = addChipToCart;

var _actions = require('../helpers/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_LINE_ITEM_INPUT = exports.SET_LINE_ITEM_INPUT = (0, _symbol2.default)('SET_LINE_ITEM_INPUT');
var CLEAR_LINE_ITEM_INPUT = exports.CLEAR_LINE_ITEM_INPUT = (0, _symbol2.default)('CLEAR_LINE_ITEM_INPUT');

function setLineItemInput() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var lineItemsAsInput = (0, _actions.formatLineItemIds)(data.order);

  return { type: SET_LINE_ITEM_INPUT, lineItemsAsInput: lineItemsAsInput };
}

function clearLineItemInput() {
  return { type: CLEAR_LINE_ITEM_INPUT };
}

function addManyToCart() {
  var lineItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var oldIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    type: 'CART_ADD_MANY_ITEMS',
    promise: function promise(_ref) {
      var api = _ref.api;
      return (0, _actions.handleErrors)(api('/v2/cart-multiple').post({
        lineItems: lineItems,
        oldIds: oldIds,
        errorMessage: errorMessage
      }));
    }
  };
}

function addToCart() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'CART_ADD_ITEM',
    promise: function promise(_ref2) {
      var api = _ref2.api;
      return (0, _actions.handleErrors)(api('/v2/cart').post(data));
    }
  };
}

function addChipToCart() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = arguments[1];
  var order = arguments[2];
  var setOrderError = arguments[3];

  return {
    type: 'CART_ADD_CHIP',
    promise: function promise(_ref3) {
      var api = _ref3.api,
          dispatch = _ref3.dispatch;
      return (0, _actions.handleChipSwitch)(api('/v2/cart').post(data), dispatch, id, order, setOrderError);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/cart.js
// module id = 574
// module chunks = 0